import { render } from "./PantrySearchTagItem.vue?vue&type=template&id=46fe15aa&scoped=true&ts=true"
import script from "./PantrySearchTagItem.vue?vue&type=script&lang=ts"
export * from "./PantrySearchTagItem.vue?vue&type=script&lang=ts"

import "./PantrySearchTagItem.vue?vue&type=style&index=0&id=46fe15aa&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fe15aa"]])

export default __exports__